import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { CellContext, Link } from '@dbt-labs/sourdough';

import { RuleSeverityEnum } from '@/__generated__/graphql';
import { toTitleCase } from '@/util/string';

interface SeverityProps {
  severity: RuleSeverityEnum;
  className?: string;
  size?: 'small' | 'standard';
  tooltip?: string;
}

export const severityClassNames: Record<RuleSeverityEnum, string> = {
  LOW: 'bg-bgBadgeEmeraldMuted',
  MEDIUM: 'bg-bgBadgeAmberMuted',
  HIGH: 'bg-bgBadgeRedMuted',
};

export const RuleSeverityBadge: FC<SeverityProps> = ({ severity, size, className }) => {
  const bg = severityClassNames[severity.toUpperCase() as RuleSeverityEnum];
  const wrapperClassname = twMerge(
    'inline-flex items-center rounded-md px-1.5 py-0.5 text-fgMain',
    bg,
    size === 'small' && 'h-6 leading-6',
    size === 'standard' && 'py-1',
    className,
  );
  return (
    <div className={wrapperClassname}>{toTitleCase(severity.toLocaleLowerCase())}</div>
  );
};

type RuleSeverityCellProps = CellContext<any, RuleSeverityEnum> & {
  href: string;
};

export const RuleSeverityCell: FC<RuleSeverityCellProps> = ({ getValue, href }) => {
  return (
    <Link isInternal to={href}>
      <RuleSeverityBadge severity={getValue()} size="small" className="w-full" />
    </Link>
  );
};
